import { Component, OnInit } from '@angular/core';
import { Search } from './../../../shared/user.model';
import swal from 'sweetalert2';
import { ErrorHandler } from './../../../shared/ErrorHandler';
import { RegistrationService } from './../../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-budget-grid',
  templateUrl: './budget-grid.component.html',
  styleUrls: ['./budget-grid.component.css']
})
export class BudgetGridComponent implements OnInit {
  maintitle = "Budget Creation";
  title = "Budget";

  isSearch: boolean;  
  itemsPerPage: number=5;
  totalItems: number;
  currentPage: number=1;
  BudgetList:any={};
  Expenditure:any={};
  s: Search;
  data: any;
  Budget_Id:number;
  B:any={};
  Budget:any={};

  constructor(private userService: RegistrationService, private route: ActivatedRoute, private router: Router, private errorHandler:ErrorHandler)  
  { 
    this.s=new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.GetAllBudget(this.itemsPerPage, 1);
  }


  SetUrl(Id:any,budgetyear:any,mode:any)
  {
    localStorage.setItem('budgetId',Id);
    localStorage.setItem('budgetyear',budgetyear);
    localStorage.setItem('mode', mode);
  }
  pageChanged(pageNumber:number)
  {
    ;
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearchBudget(this.s, this.itemsPerPage, pageNumber);
    else
    this.GetAllBudget(this.itemsPerPage, pageNumber);
  }
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearchBudget(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllBudget(this.itemsPerPage, pageNo);
  }
  

  //delete
  delete(Budget_Year){
    swal({
         title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
        this.data = this.userService.DeleteBudget(Budget_Year);
        this.data.subscribe(
         (response: any) => {
             this.GetAllBudget(this.itemsPerPage,this.currentPage);          
         },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }       
      ); 
    } 
    })
    }

    //Grid value
  GetAllBudget(itemsPerPage: number, pageNo: number) 
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllBudget(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.BudgetList=data.BudgetModel;          
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;          
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  //on search for Budget 
onSearchBudget(s, itemsPerPage: number, pageNo: number) {
  this.isSearch = true;
  let searchText = this.s.SearchText;
  let searchCriteria = this.s.SearchCriteria;
  if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
    swal("Warning!", "Please enter the search criteria and search text.", "warning");
  else {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.onSearchBudget(searchCriteria, searchText, itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          if(data.BudgetModel.length!=0){              
          this.BudgetList = data.BudgetModel;
          this.totalItems = data.TotalItemsCount;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }
        else
        {
        document.getElementById('loader-spinner').style.display = "none";         
        }
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
  }
}

// ClearSearch(){
//   this.s=new Search();
// this.GetAllBudget(this.itemsPerPage, 1);
// }

}



// WEBPACK FOOTER //
// ./src/app/finance/budget/budget-grid/budget-grid.component.ts